import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import { Divider } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { recursoService } from '../../aplicacion/addRecurso'
import Grid from '@material-ui/core/Grid'

// import Pagination from '@material-ui/lab/Pagination'

// import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
// import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import { useHistory } from 'react-router'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '30px',
    width: '100%',
    maxWidth: 750,
    backgroundColor: theme.palette.background.paper,
  },
  text: {
    color: '#C80019',
  },
  inline: {
    display: 'inline',
  },
  item: {
    minHeight: 140,
    alignItems: 'center',
  },
  gridImagen: {
    textAlign: 'center',
  },
  gridTexto: {},
  rounded: {
    width: theme.spacing(20),
    height: theme.spacing(10),
    marginRight: theme.spacing(3),
    color: '#fff',
    objectFit: 'contain',
  },
  etiquetas: {
    color: '#7030A0',
    fontWeight: 'bold',
  },
}))

const mostrarLinkTitulo = recurso => {
  if (recurso.link) {
    return (
      <Link href={recurso.link} target="_blank">
        {recurso.nombre}
      </Link>
    )
  }
  return recurso.nombre
}

const mostrarImagen = (recurso, estilos) => {
  if (recurso.imagen) {
    return <img alt={recurso.nombre} src={recurso.imagen} className={estilos.rounded} />
  }
  return <img alt="imagen no encontrada" src={`/imagenes/imagennoencontrada.jpg`} className={estilos.rounded} />
}

const printTags = recurso => {
  if (recurso.etiquetas) {
    return recurso.etiquetas.map(etiqueta => `#${etiqueta} `)
  }
}

export const ListadoRecursos = ({ recursos }) => {
  const classes = useStyles()
  const history = useHistory()

  return (
    // <Grid container className={classes.gridGeneral}>
    <List className={classes.root}>
      {recursos.map(recurso => {
        const labelId = `checkbox-list-secondary-label-${recurso}`
        return (
          <>
            <ListItem key={recurso.id}>
              <Grid container spacing={2} className={classes.item}>
                <Grid item xs={12} sm={3} className={classes.gridImagen}>
                  <ListItemAvatar>
                    <Link href={recurso.link} target="_blank">
                      {mostrarImagen(recurso, classes)}
                    </Link>
                  </ListItemAvatar>
                </Grid>
                <Grid item xs={12} sm={9} className={classes.gridTexto}>
                  <ListItemText
                    className={classes.text}
                    id={labelId}
                    primary={mostrarLinkTitulo(recurso)}
                    secondary={
                      <>
                        <Typography component="span" variant="body2" className={classes.inline} color="textPrimary">
                          <dt>{recurso.destinatario}</dt>
                        </Typography>
                        <dt>{recurso.descripcion}</dt>
                        <dt className={classes.etiquetas}>{printTags(recurso)}</dt>
                      </>
                    }
                  />

                  {process.env.REACT_APP_VERSION === 'local' && (
                    <>
                      <IconButton aria-label="delete" onClick={() => recursoService.delete(recurso)}>
                        <DeleteIcon />
                      </IconButton>
                      <IconButton aria-label="edit" onClick={() => history.push(`/form/${recurso.id}`)}>
                        <EditIcon />
                      </IconButton>
                    </>
                  )}
                </Grid>
              </Grid>
            </ListItem>
            <Divider />
          </>
        )
      })}
    </List>
    // </Grid>
  )
}
// export default function PaginationButtons() {
//   const classes = useStyles()

//   return (
//     <div className={classes.root}>
//       <Pagination count={10} showFirstButton showLastButton />
//     </div>
//   )
// }
